import { types } from "../types/types";
import { 
  URL_GET_LISTA_PROVEEDORES_SOLICITUDES,
  URL_LISTA_COMENTARIOS,
  URL_NUEVO_COMENTARIO,
  URL_CERRAR_SOLICITUD,
  URL_CONFIRMAR_LECTURA,
  URL_CARGAR_DOCUMENTO_SOLICITUD,
  URL_LISTA_ARCHIVOS_POR_SOLICITUD,
  URL_GET_FILE,
  URL_BORRAR_DOCUMENTO_SOLICITUD
} from "../../constants/url";
import { get, post, postFile } from "../../utils/fetch";
import { notification } from "./notificationActions";
import {
  composeErrorNotification,
  composeSuccessNotification,
} from "../../utils/composeNotification";

// obtener todas las solicitudes de todos los proveedores
export const getSolicitudes = () => {
  return async (dispatch) => {
    dispatch(setLoadingAtencion(true));
    
    try {
      const response = await get(URL_GET_LISTA_PROVEEDORES_SOLICITUDES);
      
      if (Array.isArray(response)) {
        dispatch(storeAtencion(response));
        
        // calcular mensajes no leídos
        const totalNoLeidos = response.reduce((acc, sol) => 
          acc + (sol.ultimoComentarioHistorial && !sol.ultimoComentarioHistorial.leido ? 1 : 0), 0);
        dispatch(setMensajesNoLeidosAtencion(totalNoLeidos));
        
        // obtener últimos mensajes para cada solicitud
        response.forEach(solicitud => {
          dispatch(getUltimoMensajeSolicitud(solicitud.proveedorSolicitudID));
        });
      } else if (response.code !== -1) {
        dispatch(storeAtencion(response.data));
      } else {
        dispatch(notification(composeErrorNotification("getSolicitudes", response.error || "error desconocido")));
      }
    } catch (error) {
      dispatch(notification(composeErrorNotification("getSolicitudes", error.message)));
    }
    
    dispatch(setLoadingAtencion(false));
  };
};

// obtener historial de una solicitud
export const getHistorialSolicitud = (solicitudId) => {
  return async (dispatch) => {
    dispatch(setLoadingAtencion(true));
    
    try {
      const response = await get(`${URL_LISTA_COMENTARIOS}/${solicitudId}`);
      
      if (Array.isArray(response)) {
        dispatch(storeHistorialAtencion(response));
        dispatch(setSolicitudActivaAtencion(solicitudId));
      } else if (response.code !== -1) {
        dispatch(storeHistorialAtencion(response.data));
        dispatch(setSolicitudActivaAtencion(solicitudId));
      } else {
        dispatch(notification(composeErrorNotification("getHistorial", response.error)));
      }
    } catch (error) {
      dispatch(notification(composeErrorNotification("getHistorial", error.message)));
    }
    
    dispatch(setLoadingAtencion(false));
  };
};

// enviar mensaje
export const addMensaje = (mensajeData) => {
  return async (dispatch) => {
    const payload = {
      solicitudID: mensajeData.solicitudID,
      comentario: mensajeData.comentario
    };
    
    const tempMensaje = {
      proveedorSolicitudHistorialID: Date.now(),
      comentario: payload.comentario,
      fechaCreacion: new Date().toISOString(),
      usuarioNombre: "admin",
      leido: true,
      isTemporary: true
    };
    dispatch(addMensajeOptimistaAtencion(tempMensaje));
    
    try {
      const response = await post(URL_NUEVO_COMENTARIO, payload);
      
      if (response.success || response.code === 0) {
        dispatch(notification(composeSuccessNotification("mensaje enviado")));
        dispatch(getHistorialSolicitudSilencioso(payload.solicitudID));
      } else {
        dispatch(removeMensajeOptimistaAtencion(tempMensaje.proveedorSolicitudHistorialID));
        dispatch(notification(composeErrorNotification("addMensaje", response.error)));
      }
    } catch (error) {
      dispatch(removeMensajeOptimistaAtencion(tempMensaje.proveedorSolicitudHistorialID));
      dispatch(notification(composeErrorNotification("addMensaje", error.message)));
    }
  };
};

// cerrar solicitud
export const cerrarSolicitud = (solicitudId) => {
  return async (dispatch) => {
    dispatch(updateSolicitudEstatusAtencion(solicitudId, "cerrado"));
    
    try {
      const payload = { solicitudID: solicitudId };
      const response = await post(URL_CERRAR_SOLICITUD, payload);
      
      if (response.success || response.code === 0) {
        dispatch(notification(composeSuccessNotification("solicitud cerrada exitosamente")));
        dispatch(getSolicitudesSilencioso());
      } else {
        dispatch(updateSolicitudEstatusAtencion(solicitudId, "abierto"));
        dispatch(notification(composeErrorNotification("cerrarSolicitud", "error al cerrar solicitud")));
      }
    } catch (error) {
      dispatch(updateSolicitudEstatusAtencion(solicitudId, "abierto"));
      dispatch(notification(composeErrorNotification("cerrarSolicitud", error.message)));
    }
  };
};

// confirmar lectura
export const confirmarLecturaComentario = (solicitudId) => {
  return async (dispatch) => {
    try {
      const payload = { solicitudID: solicitudId };
      await post(URL_CONFIRMAR_LECTURA, payload);
      dispatch(getSolicitudesSilencioso());
    } catch (error) {
      console.warn('error confirmando lectura:', error);
    }
  };
};

// action creators
const storeAtencion = (payload) => ({
  type: types.storeAtencion,
  payload
});

const storeHistorialAtencion = (payload) => ({
  type: types.storeHistorialAtencion,
  payload
});

const setLoadingAtencion = (payload) => ({
  type: types.setLoadingAtencion,
  payload
});

const setSolicitudActivaAtencion = (payload) => ({
  type: types.setSolicitudActivaAtencion,
  payload
});

const setMensajesNoLeidosAtencion = (payload) => ({
  type: types.setMensajesNoLeidosAtencion,
  payload
});

const addMensajeOptimistaAtencion = (payload) => ({
  type: types.addMensajeOptimistaAtencion,
  payload
});

const removeMensajeOptimistaAtencion = (payload) => ({
  type: types.removeMensajeOptimistaAtencion,
  payload
});

const updateSolicitudEstatusAtencion = (solicitudId, estatus) => ({
  type: types.updateSolicitudEstatusAtencion,
  payload: { solicitudId, estatus }
});

const storeUltimoMensajeAtencion = (payload) => ({
  type: types.storeUltimoMensajeAtencion,
  payload
});

// funciones silenciosas
export const getSolicitudesSilencioso = () => {
  return async (dispatch) => {
    try {
      const response = await get(URL_GET_LISTA_PROVEEDORES_SOLICITUDES);
      
      if (Array.isArray(response)) {
        dispatch(storeAtencion(response));
        const totalNoLeidos = response.reduce((acc, sol) => 
          acc + (sol.ultimoComentarioHistorial && !sol.ultimoComentarioHistorial.leido ? 1 : 0), 0);
        dispatch(setMensajesNoLeidosAtencion(totalNoLeidos));
        
        // obtener últimos mensajes para cada solicitud
        response.forEach(solicitud => {
          dispatch(getUltimoMensajeSolicitud(solicitud.proveedorSolicitudID));
        });
      } else if (response.code !== -1) {
        dispatch(storeAtencion(response.data));
        
        // obtener últimos mensajes para cada solicitud
        if (response.data && Array.isArray(response.data)) {
          response.data.forEach(solicitud => {
            dispatch(getUltimoMensajeSolicitud(solicitud.proveedorSolicitudID));
          });
        }
      }
    } catch (error) {
      console.warn('error en getSolicitudesSilencioso:', error);
    }
  };
};

export const getHistorialSolicitudSilencioso = (solicitudId) => {
  return async (dispatch) => {
    try {
      const response = await get(`${URL_LISTA_COMENTARIOS}/${solicitudId}`);
      
      if (Array.isArray(response)) {
        dispatch(storeHistorialAtencion(response));
      } else if (response.code !== -1) {
        dispatch(storeHistorialAtencion(response.data));
      }
    } catch (error) {
      console.warn('error en getHistorialSolicitudSilencioso:', error);
    }
  };
};

export const getUltimoMensajeSolicitud = (solicitudId) => {
  return async (dispatch) => {
    try {
      const response = await get(`${URL_LISTA_COMENTARIOS}/${solicitudId}`);
      
      if (Array.isArray(response) && response.length > 0) {
        const mensajesReales = response.filter(msg => !msg.isTemporary);
        if (mensajesReales.length > 0) {
          const ultimoMensaje = mensajesReales[mensajesReales.length - 1];
          dispatch(storeUltimoMensajeAtencion({
            solicitudId,
            ultimoMensaje: {
              comentario: ultimoMensaje.comentario,
              fechaCreacion: ultimoMensaje.fechaCreacion,
              usuarioNombre: ultimoMensaje.usuarioNombre
            }
          }));
        }
      } else if (response.code !== -1 && response.data && response.data.length > 0) {
        const mensajesReales = response.data.filter(msg => !msg.isTemporary);
        if (mensajesReales.length > 0) {
          const ultimoMensaje = mensajesReales[mensajesReales.length - 1];
          dispatch(storeUltimoMensajeAtencion({
            solicitudId,
            ultimoMensaje: {
              comentario: ultimoMensaje.comentario,
              fechaCreacion: ultimoMensaje.fechaCreacion,
              usuarioNombre: ultimoMensaje.usuarioNombre
            }
          }));
        }
      }
    } catch (error) {
      console.warn('error en getUltimoMensajeSolicitud:', error);
    }
  };
};

// obtener archivos de una solicitud
export const getArchivosSolicitud = (solicitudId) => {
  return async (dispatch, getState) => {
    dispatch(setLoadingArchivos(true));
    
    try {
      const response = await get(`${URL_LISTA_ARCHIVOS_POR_SOLICITUD}/${solicitudId}`);
      
      if (Array.isArray(response)) {
        // enriquecer archivos con datos de usuario
        const { atencionReducer, userReducer } = getState();
        const solicitudes = atencionReducer.solicitudes || [];
        const currentUser = userReducer.user;
        
        const archivosEnriquecidos = response.map(archivo => {
          const solicitud = solicitudes.find(s => s.proveedorSolicitudID == archivo.proveedorSolicitudID);
          
          // determinar si es archivo de admin o proveedor
          let usuarioNombre = archivo.usuarioNombre;
          let usuarioID = archivo.usuarioID;
          let esAdmin = false;
          
          if (!usuarioNombre || usuarioNombre === "Usuario desconocido") {
            // si el usuarioID coincide con el admin actual, es del admin
            if (currentUser && archivo.usuarioID === currentUser.usuarioID) {
              usuarioNombre = currentUser.nombreCompleto || currentUser.nombre || "Admin";
              usuarioID = currentUser.usuarioID;
              esAdmin = true;
            } 
            // si no, probablemente es del proveedor original
            else {
              usuarioNombre = solicitud?.proveedorUsuarioNombre || "Usuario desconocido";
              usuarioID = solicitud?.proveedorUsuarioID;
              esAdmin = false;
            }
          } else {
            // si ya tiene nombre, determinar si es admin basado en el nombre o ID
            esAdmin = usuarioNombre?.toLowerCase().includes('admin') || 
                     usuarioNombre?.toLowerCase().includes('soporte') ||
                     (currentUser && archivo.usuarioID === currentUser.usuarioID);
          }
          
          return {
            ...archivo,
            usuarioNombre,
            usuarioID,
            esAdmin,
            tipoUsuario: esAdmin ? 'admin' : 'proveedor'
          };
        });
        
        dispatch(storeArchivosSolicitud(archivosEnriquecidos));
      } else if (response.code !== -1) {
        const { atencionReducer, userReducer } = getState();
        const solicitudes = atencionReducer.solicitudes || [];
        const currentUser = userReducer.user;
        
        const archivosEnriquecidos = (response.data || []).map(archivo => {
          const solicitud = solicitudes.find(s => s.proveedorSolicitudID == archivo.proveedorSolicitudID);
          
          // determinar si es archivo de admin o proveedor
          let usuarioNombre = archivo.usuarioNombre;
          let usuarioID = archivo.usuarioID;
          let esAdmin = false;
          
          // si el archivo no tiene información de usuario (backend no la provee)
          if (!usuarioNombre || usuarioNombre === "Usuario desconocido") {
            // si el usuarioID coincide con el admin actual, es del admin
            if (currentUser && archivo.usuarioID === currentUser.usuarioID) {
              usuarioNombre = currentUser.nombreCompleto || currentUser.nombre || "Admin";
              usuarioID = currentUser.usuarioID;
              esAdmin = true;
            } 
            // si no, probablemente es del proveedor original
            else {
              usuarioNombre = solicitud?.proveedorUsuarioNombre || "Usuario desconocido";
              usuarioID = solicitud?.proveedorUsuarioID;
              esAdmin = false;
            }
          } else {
            // si ya tiene nombre, determinar si es admin basado en el nombre o ID
            esAdmin = usuarioNombre?.toLowerCase().includes('admin') || 
                     usuarioNombre?.toLowerCase().includes('soporte') ||
                     (currentUser && archivo.usuarioID === currentUser.usuarioID);
          }
          
          return {
            ...archivo,
            usuarioNombre,
            usuarioID,
            esAdmin,
            tipoUsuario: esAdmin ? 'admin' : 'proveedor'
          };
        });
        
        dispatch(storeArchivosSolicitud(archivosEnriquecidos));
      } else {
        dispatch(notification(composeErrorNotification("getArchivosSolicitud", response.error)));
      }
    } catch (error) {
      dispatch(notification(composeErrorNotification("getArchivosSolicitud", error.message)));
    }
    
    dispatch(setLoadingArchivos(false));
  };
};

// subir archivo
export const subirArchivo = (solicitudId, file) => {
  return async (dispatch) => {
    dispatch(setSubiendoArchivo(true));
    
    try {
      const formData = new FormData();
      formData.append('proveedorSolicitudID', solicitudId);
      formData.append('file', file);
      
      const response = await postFile(URL_CARGAR_DOCUMENTO_SOLICITUD, formData);
      
      if (response.success || response.code === 0) {
        dispatch(notification(composeSuccessNotification("archivo subido exitosamente")));
        dispatch(getArchivosSolicitud(solicitudId));
      } else {
        dispatch(notification(composeErrorNotification("subirArchivo", response.error || "error al subir archivo")));
      }
    } catch (error) {
      dispatch(notification(composeErrorNotification("subirArchivo", error.message)));
    }
    
    dispatch(setSubiendoArchivo(false));
  };
};

// descargar archivo
export const descargarArchivo = (documentoID, nombreArchivo) => {
  return async (dispatch) => {
    try {
      const response = await fetch(`${URL_GET_FILE}/${documentoID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = nombreArchivo;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        dispatch(notification(composeSuccessNotification("archivo descargado")));
      } else {
        dispatch(notification(composeErrorNotification("descargarArchivo", "error al descargar archivo")));
      }
    } catch (error) {
      dispatch(notification(composeErrorNotification("descargarArchivo", error.message)));
    }
  };
};

// eliminar archivo
export const eliminarArchivo = (documentoID, solicitudId) => {
  return async (dispatch) => {
    try {
      const response = await get(`${URL_BORRAR_DOCUMENTO_SOLICITUD}/${documentoID}`);
      
      if (response.success || response.code === 0) {
        dispatch(notification(composeSuccessNotification("archivo eliminado")));
        dispatch(getArchivosSolicitud(solicitudId));
      } else {
        dispatch(notification(composeErrorNotification("eliminarArchivo", response.error || "error al eliminar archivo")));
      }
    } catch (error) {
      dispatch(notification(composeErrorNotification("eliminarArchivo", error.message)));
    }
  };
};

// recarga completa silenciosa
export const reloadAllSilencioso = (solicitudIdActiva = null) => {
  return async (dispatch) => {
    // 1. recargar lista principal de solicitudes (incluye últimos mensajes)
    dispatch(getSolicitudesSilencioso());
    
    // 2. si hay una solicitud activa, recargar su historial y archivos
    if (solicitudIdActiva) {
      dispatch(getHistorialSolicitudSilencioso(solicitudIdActiva));
      dispatch(getArchivosSolicitud(solicitudIdActiva));
    }
  };
};

// action creators adicionales para archivos
const storeArchivosSolicitud = (payload) => ({
  type: types.storeArchivosSolicitud,
  payload
});

const setLoadingArchivos = (payload) => ({
  type: types.setLoadingArchivos,
  payload
});

const setSubiendoArchivo = (payload) => ({
  type: types.setSubiendoArchivo,
  payload
});